import React from "react";
import { ReservTable } from "./ReservTable";
import { DetailsHeader } from "./DetailsHeader";
import { DetailsCard } from "./DetailsCard";

export const GroupReservDetails = () => {
  return (
    <div className="container-fluid">
      <DetailsHeader />
      <DetailsCard />
      <ReservTable />
    </div>
  );
};
